import { BehaviorSubject, filter, Observable } from 'rxjs';

export class TableUIDataSource<DataType> {
  private _data: DataType[] = [];
  private _filter: string | null = null;
  private _sort: unknown | null = null;
  private _paginator: unknown | null = null;

  private _data$ = new BehaviorSubject<DataType[]>([]);

  public readonly dataTypeRef!: DataType;
  public data$: Observable<DataType[]> = this._data$.pipe(filter(Boolean));

  // TODO: setters and getters for table data manipulations on the client side. No BE needed
  // TODO: implement later #00000
  set data(data: DataType[]) {
    this._data = data;
  }

  get data(): DataType[] {
    return this._data;
  }

  // TODO: implement later #00000
  set filter(filterString: string | null) {}

  get filter(): string | null {
    return this._filter;
  }

  // TODO: implement later #00000
  get sort(): unknown {
    return this._sort;
  }

  set sort(sort: unknown) {
    this._sort = sort;
  }

  // TODO: implement later #00000
  get paginator(): unknown | null {
    return this._paginator;
  }

  set paginator(paginator: unknown | null) {
    this._paginator = paginator;
  }

  constructor(data: DataType[]) {
    this._data$.next((this._data = data));
  }
}
